export const ENROLLMENTS_1_CONSTANTS = {
  ENROLLMENTS_FIELDS_CONFIG: [
    {
      fieldName: "headline",
      label: "Headline",
      value: "Ready to Take the Next Step? Enroll Today!",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Ready to Take the Next Step? Enroll Today!",
      required: false,
      defaultValue: "Ready to Take the Next Step? Enroll Today!",
      rows: 3,
    },
    {
      fieldName: "cta_label",
      label: "Button label",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Apply Now",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_url",
      label: "Button URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/path or https:// — used when Is CTA is off",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "open_in_new_tab",
      label: "Open link in new tab",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "enable_lead_popup",
      label: "Is CTA — open lead popup",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = lead capture popup instead of button URL",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "desktop_image",
      label: "Desktop section background image (optional — behind the card)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop background image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_image",
      label: "Mobile background image (optional — falls back to desktop)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload mobile background image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "outer_background_color",
      label: "Outer frame color",
      value: "#FDE1D1",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FDE1D1",
      required: false,
      defaultValue: "#FDE1D1",
    },
    {
      fieldName: "inner_background_color",
      label: "Inner card color",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DB5803",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "headline_color",
      label: "Headline color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_background_color",
      label: "Button background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_text_color",
      label: "Button text color",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DB5803",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],
};
